export default __webpack_public_path__ + "static/media/Circlet of the Sepulcher.425dfacc.jpg";